import { Box, Container, Grid2 as Grid, Typography } from '@mui/material'
import React from 'react'

import UserCard from '../components/cards/UserCard'
import EmptyStateCard from '../components/common/EmptyStateCard'

export default function DemoComp() {
  // Sample user data
  const sampleUser = {
    resourceId: 'user-001',
    name: 'John Snow',
    email: 'john.snow@example.com',
    avatar: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
    bio: `# Professional Ski Instructor

With over 10 years of experience teaching skiing to all levels, from beginners to advanced skiers.

## Teaching Philosophy
- Focus on individual learning styles
- Safety first approach
- Progressive skill development

> "The best way to learn is to challenge yourself while having fun!"`,
    sports: ['SKI', 'SNOWBOARD'],
    certificates: ['CSIA Level 3', 'CASI Level 2'],
    certificateVerified: true,
  }

  const instructorUser = {
    ...sampleUser,
    resourceId: 'instructor-001',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@example.com',
    bio: `# Elite Snowboard Instructor

15+ years of competitive snowboarding experience. Specialized in teaching advanced techniques and park riding.

## Expertise Areas
- Park & Freestyle
- Advanced carving
- Competition training

## Achievements
- National Championship Gold (2019)
- Certified Level 4 Instructor
- Youth Program Director`,
    sports: ['SNOWBOARD'],
    certificates: ['CASI Level 4', 'Freestyle Cert Level 2'],
    certificateVerified: true,
  }

  const beginnerInstructor = {
    ...sampleUser,
    resourceId: 'instructor-002',
    name: 'Mike Chen',
    email: 'mike.chen@example.com',
    bio: '新手友好的滑雪教练，擅长帮助初学者克服恐惧，建立信心。注重安全和基础技巧的培养。',
    sports: ['SKI'],
    certificates: ['CSIA Level 1'],
    certificateVerified: false,
  }

  return (
    <Container maxWidth="100%">
      <Grid container spacing={4} sx={{ my: 4 }}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h4" gutterBottom>
            UserCard Component Demo
          </Typography>
        </Grid>

        {/* Large Size Examples */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" gutterBottom>
            Large Size Card
          </Typography>
          <Box sx={{ mb: 4 }}>
            <UserCard user={instructorUser} size="large" />
          </Box>
        </Grid>

        {/* Medium Size Examples */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" gutterBottom>
            Medium Size Cards
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <UserCard user={sampleUser} size="medium" />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <UserCard user={beginnerInstructor} size="medium" bio={false} />
            </Grid>
          </Grid>
        </Grid>

        {/* Small Size Examples */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" gutterBottom>
            Small Size Cards
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}>
              <UserCard user={sampleUser} size="small" />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <UserCard user={instructorUser} size="small" bio={false} />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <UserCard user={beginnerInstructor} size="small" bio={false} />
            </Grid>
          </Grid>
        </Grid>

        {/* Variations */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" gutterBottom>
            Variations
          </Typography>
          <Grid container spacing={2}>
            {/* Without Bio */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" gutterBottom>
                Without Bio
              </Typography>
              <UserCard user={sampleUser} bio={false} />
            </Grid>
            {/* Without Certificates */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" gutterBottom>
                Without Certificates
              </Typography>
              <UserCard
                user={{
                  ...sampleUser,
                  certificates: [],
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Empty State Card Examples */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" gutterBottom>
            Empty State Card Examples
          </Typography>
          <Grid container spacing={2}>
            {/* Basic Empty State */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" gutterBottom>
                Basic Empty State
              </Typography>
              <EmptyStateCard title="No Items Found" subtitle="There are currently no items to display" />
            </Grid>
            {/* With Action Button */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" gutterBottom>
                With Action Button
              </Typography>
              <EmptyStateCard
                title="No Sessions Available"
                subtitle="Create a new session or check back later"
                buttonText="Create New Session"
                onButtonClick={() => console.debug('Create session clicked')}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
